import { render, staticRenderFns } from "./TargetingModal.vue?vue&type=template&id=ec80593c&scoped=true&"
import script from "./TargetingModal.vue?vue&type=script&lang=js&"
export * from "./TargetingModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec80593c",
  null
  
)

export default component.exports